import { Component, Input, OnInit } from '@angular/core';
import { Project } from 'src/app/model/project/project';
import { ProjectExtraCompanyContact } from 'src/app/model/project/project-extra-company-contact';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { STATUS } from '../../../model/project/status';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'extra-company-contact-picker',
  templateUrl: './extra-company-contact-picker.component.html',
  styleUrls: ['./extra-company-contact-picker.component.scss'],
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class ExtraCompanyContactPicker implements OnInit {
  @Input()
  project: Project;

  @Input()
  disabled: boolean = false;

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {}

  ngOnInit(): void {
    if (
      this.project.id == null ||
      this.project.subProjects[0]?.status === STATUS.DRAFT.valueOf()
    ) {
      if (this.project.projectExtraCompanyContacts == null) {
        this.project.projectExtraCompanyContacts = [
          new ProjectExtraCompanyContact(),
        ];
      } else if (this.project.projectExtraCompanyContacts.length === 0) {
        this.project.projectExtraCompanyContacts.push(
          new ProjectExtraCompanyContact()
        );
      }
    }
  }

  addExtraCompanyContact(): void {
    this.project.projectExtraCompanyContacts.push(
      new ProjectExtraCompanyContact()
    );
    this.projectDisplayObservableService
      .getProjectExtraCompanyContactsChangedSubscribable()
      .next();
  }

  deleteExtraCompanyContact(index: number): void {
    this.project.projectExtraCompanyContacts.splice(index, 1);
    this.projectDisplayObservableService
      .getProjectExtraCompanyContactsChangedSubscribable()
      .next();
  }
}
